import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import GreenListInfo from "./GreenListInfo";
import GreenListHelpPopup from "./GreenListHelpPopup";
import GreenListPopup, { GreenListMode } from "./GreenListPopup";
import GreenListRemovePopUp from "./GreenListRemovePopUp";
import { JQModal } from "../Popup/Utils";
import { GreenListStatus, sortAreaAndUpdateServices } from "@eres/greenlistapi/entities";
import { hideLoading, setLoading, showLoading } from "@my-dld/utils/UIUtils";
import { GreenListApi } from "@eres/greenlistapi";
import { TabuProfile } from "@10x/sso/TabuProfile";
import * as SSO from "@10x/sso";
import { hasRole } from "@10x/sso";
import { TABU_OWNER } from "@10x/sso/roles";
import { SpinnerLoader } from "../SpinnerLoader";

interface Props {
}

interface State {
	glSubscription?: GreenListStatus;
	showSubscribe?: boolean;
	showUnsubscribe?: boolean;
	isLoading: boolean;
	actionMode: GreenListMode;
}

class GreenList extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: false,
			actionMode: "SUBSCRIBE",
		};
	}

	componentDidMount() {
		if ( hasRole( TABU_OWNER ) ) {
			this.refreshStatus();
		}
	}

	refreshStatus = () => {
		setLoading( this, true );
		GreenListApi.getStatus( TabuProfile.getParticipantId() ).then( r => {
			hideLoading();
			if ( r && r.Response ) {
				let m: GreenListStatus = {
					...r.Response,
					ServiceTypes: sortAreaAndUpdateServices( r.Response.ServiceTypes ),
				};
				setLoading( this, false, { glSubscription: m } );
			} else {
				setLoading( this, false, { glSubscription: undefined } );
			}
		} ).catch( _e => {
			setLoading( this, false, { glSubscription: undefined } );
		} );
	};

	render() {
		if ( !hasRole( TABU_OWNER ) ) {
			return null;
		}
		const {
			glSubscription, showUnsubscribe, showSubscribe, actionMode, isLoading,
		} = this.state;
		const isGlSubscribed = glSubscription != null;
		if ( isLoading ) return <div className="card green-list-feature p-3"><SpinnerLoader/></div>;
		return (
			<div className="card green-list-feature">
				<div className="card-header">
					<span>{ Strings.green_list }</span>
				</div>
				<div className="card-body">
                    <div className="green-list-switch">
                        <div className="mb-3">{Strings.green_list_info}</div>
                        <span className="me-3">{Strings.allow_brokers_contact}</span>
						<div className="btn-group btn-toggle btn-custom-toggle">
							<button
								type="button" className={ isGlSubscribed ? "btn active" : "btn" }
								onClick={ this.showGreenListSubscription }>{ Strings.yes }
							</button>
							<button
								type="button" className={ !isGlSubscribed ? "btn active" : "btn" }
								onClick={ this.showGreenListUnSubscription }>{ Strings.no }
							</button>
						</div>
					</div>
					<GreenListInfo subscription={ glSubscription } onUpdateSubscription={ this.onUpdateSubscription }/>
				</div>
				<GreenListHelpPopup/>
				{ showSubscribe && <GreenListPopup
					onSubscriptionUpdated={ this.onGlUpdated }
					onDismiss={ () => this.setState( { showSubscribe: false } ) }
					subscription={ glSubscription }
					mode={ actionMode }/> }
				{ showUnsubscribe && <GreenListRemovePopUp
					onAccept={ () => {
						JQModal( "GreenListRemove" ).hide();
						this.updateGreenListStatus( undefined );
					} }
					onDismiss={ () => this.setState( { showUnsubscribe: false } ) }/> }
			</div>
		);
	}

	onUpdateSubscription = () => {
		this.setState( {
			actionMode: "UPDATE",
			showSubscribe: false,
		}, () => {
			this.setState( {
				showSubscribe: true,
			}, () => JQModal( "GreenListPopup" ).show() );
		} );
	};
	updateGreenListStatus = ( subscription?: GreenListStatus ) => {
		showLoading();
		const { glSubscription } = this.state;
		let request: GreenListStatus = {
			ParticipantId: TabuProfile.getParticipantId(),
			NameAr: SSO.getName()! ? SSO.getName()?.ar : "",
			NameEn: SSO.getName()! ? SSO.getName()?.en : "",
			Mobile: subscription?.Mobile ?? glSubscription?.Mobile,
			Email: subscription?.Email ?? glSubscription?.Email,
			Notes: "",
			// FIX ME
			// ExpiryDate: isAvailable ? this.state.subscriptionEndDate ? this.state.subscriptionEndDate : "" : "",
			ExpiryDate: "",
			IsActive: subscription != null,
			TotalRowsCount: 0,
			ServiceTypes: subscription?.ServiceTypes
		};
		return GreenListApi.updateStatus( request ).then( r => {
			hideLoading();
			if ( r && r.Response && r.Response.IsActive ) {
				this.setState( {
					//  glSubscription: r.Response,
				} );
			} else {
				this.setState( {
					glSubscription: undefined,
				} );
			}
		} ).catch( _e => {
			hideLoading();
			this.setState( {
				glSubscription: undefined,
			} );
		} );
	};

	showGreenListSubscription = () => {
		const sub = this.state.glSubscription;
		if ( sub == null ) {
			this.setState( {
				showSubscribe: true,
				actionMode: "SUBSCRIBE",
			}, () => {
				JQModal( "GreenListPopup" ).show();
			} );
		}
	};
	showGreenListUnSubscription = () => {
		const sub = this.state.glSubscription;
		if ( sub != null ) {
			this.setState( {
				showUnsubscribe: true,
			}, () => {
				JQModal( "GreenListRemove" ).show();
			} );
		}
	};
	onGlUpdated = ( subscription: GreenListStatus ) => {
		this.setState( {
			glSubscription: subscription
		} );
		return this.updateGreenListStatus( subscription ).then( _x => {
			setTimeout( () => {
				JQModal( "GreenListPopup" ).hide( this.refreshStatus );
			} );
			return Promise.resolve();
		} );
	};
}

export default GreenList;

